import { Maximize2, Trash, EllipsisVertical, Loader2 } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { cn } from 'src/lib/utils';

const actionKeys = ['details', 'cancel'] as const;

type Props = {
  onSeePricingDetails: () => void;
  onCancelPlan: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disable?: {
    [key in (typeof actionKeys)[number]]?: string;
  };
  loading?: {
    [key in (typeof actionKeys)[number]]?: boolean;
  };
};

const CancelPlanTooltip = () => (
  <TooltipProvider delayDuration={100}>
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <DropdownMenuItem variant="destructive" disabled>
            <Trash />
            Cancel plan
          </DropdownMenuItem>
        </div>
      </TooltipTrigger>
      <TooltipContent side="top" align="center" className="max-w-[250px]">
        Your account changes are still being applied. Please wait at least 30 days before requesting more changes.
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

const BillingPlanDropdown = ({ disable, onSeePricingDetails, onCancelPlan, loading }: Props) => {
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <EllipsisVertical />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent side="bottom" align="center" className="w-max">
        <DropdownMenuItem className="py-2 cursor-pointer" onClick={onSeePricingDetails}>
          <Maximize2 />
          See pricing details
        </DropdownMenuItem>
        {disable?.cancel ? (
          <CancelPlanTooltip />
        ) : (
          <DropdownMenuItem
            variant="destructive"
            className={cn('py-2 cursor-pointer', {
              'pointer-events-none': loading?.cancel,
            })}
            onClick={onCancelPlan}
          >
            {loading?.cancel ? <Loader2 className="animate-spin" /> : <Trash />}
            Cancel plan
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BillingPlanDropdown;
